<template lang="html">

	<section class="ficha -empresa">
		
		<template v-if="!!data">

			<h2 class="ficha-title" :style="styles.colorBasic">Datos generales</h2>

			<article class="group">

				<div class="contenedor-data -full" v-if="!!data.conocimientosEspecificos">
					<h4 class="data-title" :style="styles.colorBasic">Conocimientos específicos</h4>
					<p>{{data.conocimientosEspecificos}}</p>
				</div>

				<div class="contenedor-data -full" v-if="!!data.formacionAdquirida">
					<h4 class="data-title" :style="styles.colorBasic">Formación Adquirida</h4>
					<p>{{data.formacionAdquirida}}</p>
				</div>
				
			</article>

		</template>

	</section>

</template>

<script lang="js">

	import {mapGetters, mapActions} from 'vuex';

	import onlyArrow  from '@/components/parts/icons/only-arrow';
	import arrowlink  from '@/components/parts/icons/arrow-link';

	export default  {
		name: 'ficha-datos-generales',
		props : ['data'],
		computed :{
			...mapGetters({
				styles : 'getStyles',
				brand : 'getBrand'
			})
		},
		components : {
			'only-arrow' : onlyArrow,
			'arrow-link' : arrowlink,
		}

	}
</script>

<style scoped lang="scss">
	.ficha-empresa {

	}
</style>



// WEBPACK FOOTER //
// src/components/views/aprobaciones/ficha-datos-generales.vue